import { connect } from "react-redux";

import { selectIsEditMode } from "~/store/ducks/application/materials/isEditMode";

import DragAndDropEntry from "./DragAndDropEntry";

function mapStateToProps(state) {
  return {
    isEditMode: selectIsEditMode(state)
  };
}

export default connect(mapStateToProps)(DragAndDropEntry);
